module.exports = __webpack_public_path__ + "3f93438298b68e5b28f538b1037deb07.pdf";